<template>
  <div class="soar-container">
    <div class="w-full my-8">
      <div class="flex items-center justify-between border-b border-brand-gray-350 w-full">
        <div class="py-6 w-full">
          <h2 class="text-xl text-gray-500 font-normal mx-3">
            {{ $t(props.panelTitle) }}
          </h2>
        </div>
      </div>
      <div class="w-full my-6">
        <DataTable
          :default-headers="['feesDescription', 'amount', 'sRefundable']"
          :data-set="processedDataTable"
          v-if="processedDataTable.length > 0"
          class="w-full"
        >
          <template #cell="{ columnName, columnValue, rowIndex }">
            <div class="min-h-4">{{ columnValue }}</div>
          </template>
          <template #tableFooter>
            <tr
              :key="key"
              v-for="(row, key) in formatAppendRow"
              class="odd:bg-brand-gray-100 ltr:font-sans text-xs"
            >
              <template :key="l" v-for="(col, l) in row">
                <td
                  :colspan="col?.config?.colspan"
                  class="p-1 ps-2 border border-gray-100 ltr:font-sans text-xs"
                >
                  {{ col.label }}
                </td>
                <td class="bg-white text-center">{{ col.value }}</td>
              </template>
            </tr>
          </template>
        </DataTable>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import DataTable from '@/components/DataTable/index.vue'
import apiHelperService from '@/services'
const props = defineProps({
  panelTitle: {
    type: String,
    default: 'paymentDetails'
  }
})
const processedDataTable = ref([])
const formatAppendRow = ref([])

const i18n = useI18n()
const route = useRoute()
const containsVat = ref(false)

const setTotal = (val) => {
  formatAppendRow.value = [
    [
      {
        label: i18n.t('total'),
        value: val,
        config: {
          colspan: '4'
        }
      }
    ]
  ]
}
const fetchData = async () => {
  const res = await apiHelperService.get(`/api/payment/fees/request/${route.params.id}`)
  containsVat.value = res.containsVat

  setTotal(res.total)

  processedDataTable.value = res.result.map((requestFeeSetup) => {
    return {
      feesDescription: requestFeeSetup.feeTypes.text,
      amount: requestFeeSetup.amount,
      ...(containsVat.value && {
        vatAmount: requestFeeSetup.vatAmount,
        totalWithVat: requestFeeSetup.totalVatAmountPlusAmount
      }),
      isRefundable: requestFeeSetup.refundableFlag
    }
  })
}

onMounted(async () => {
  await fetchData()
})
</script>
<style lang="scss" scoped></style>
